import type { FaireProductEntity } from "../../entity_types/product";

export const p_sm6fv59ets: FaireProductEntity = {
  token: "p_sm6fv59ets",
  type: "product",
  name: "LM-TS-1023 Logo Adult Blue Spruce Comfort Colors Tee",
  brandToken: "b_h6l667zq",
  brandName: "Girlie Girl Originals",
  imageUrl: "https://cdn.faire.com/fastly/770aa1e980d2069b0c85a54bf605b64c86db86c484b2a25aa11bf4788b35b9bb.jpeg",
  galleryImageUrls: [],
  priceDollars: 15.5,
  description: "This Girlie Girl Originals tee features a screen-printed logo on Blue Spruce Comfort Colors fabric, designed for casual wear. It is a men's screen printed t-shirt available in adult sizes and branded by Girlie Girl Originals, suited for boutiques and retailers seeking trend-savvy apparel.",
  tags: [],
  msrpDollars: 31,
  inStock: false,
  meta: {
    source: "api",
    importedAt: "2026-10-28T21:01:56.004Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
